import * as z from "zod/v4";

export const getRerunAutomationsProgress = {
  name: "getRerunAutomationsProgress" as const,
  input: z.object({}),
  output: z.object({
    rerunAutomationBatches: z.array(
      z.object({
        id: z.string(),
        totalGroups: z.number(),
        completedGroups: z.number(),
        startTime: z.string(),
      }),
    ),
  }),
};
